import { useEffect, useState } from 'react';
import customAxios, { customFormAxios } from '../util/Api';
import authHeader from 'services/auth/jwt/auth-header';
import { useDispatch } from 'react-redux';
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from '@jumbo/constants/ActionTypes';
import { useToast } from 'context/tostifyContext';

const useChipperLoader = () => {
  const dispatch = useDispatch();
  const { showToast } = useToast();

  const [spList, setSPList] = useState([]);
  const [spListObj, setSPListObj] = useState({});

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [chipperData, setChipperData] = useState([]);

  // View
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);

  // Docs
  const [docsOpen, setDocsOpen] = useState(false);
  const [selectedDocRow, setSelectedDocRow] = useState(null);
  const [files, setFiles] = useState([]);
  const [docsLoading, setDocsLoading] = useState(false);
  const [docType, setDocType] = useState('');

  useEffect(() => {
    getSPList();
    getChipperData();
  }, []);

  const getChipperData = async () => {
    try {
      const response = await customAxios.get('Ops/GetChipperLoader', { headers: authHeader() });
      if (response.status === 200) {
        setChipperData(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getSPList = () => {
    try {
      dispatch({ type: FETCH_START });
      customAxios.get('/Ops/GetContracts', { headers: authHeader() }).then(response => {
        let allData = response.data;

        let uniqueData = [];
        let uniqueDataObj = {};

        for (let i = 0; i < allData.length; i++) {
          let sp = allData[i];

          if (sp.wH_NumberName && sp.contractUniqueID) {
            const option = {
              label: `${sp.contractUniqueID} - ${sp.wH_NumberName}`,
              value: sp.contractUniqueID,
              raw: sp, // optional (VERY useful later)
            };

            uniqueData.push(option);
            uniqueDataObj[sp.contractUniqueID] = option;
          }
        }
        console.log('SP List Data', uniqueData, uniqueDataObj);
        setSPList(uniqueData);
        setSPListObj(uniqueDataObj);
        dispatch({ type: FETCH_SUCCESS });
      });
    } catch (error) {
      setSPList([]);
      dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
    }
  };

  const handleSave = async newData => {
    const res = await customAxios.post('/Ops/AddChipperLoader', newData, { headers: authHeader() });
    console.log('RES ===', res);
    if (res.status === 200) {
      getChipperData();
    }
    setIsModalOpen(false);
  };

  const handleRowSelected = data => {
    setSelectedRecord(data);
    setIsViewModalOpen(true);
  };

  const handleRecordDoubleClick = args => {
    setSelectedRecord(args.rowData);
    setIsViewModalOpen(true);
  };

  const handleViewModalClose = () => {
    setSelectedRecord(null);
    setIsViewModalOpen(false);
  };

  // ---------------------------------------------------------------------------
  // Docs
  // ---------------------------------------------------------------------------
  const fetchDocs = async docketNumber => {
    setDocsLoading(true);
    const response = await customAxios.get(`/Ops/GetDocketsDocs/${docketNumber}`, { headers: authHeader() });
    setFiles(response.data);
    setDocsLoading(false);
  };

  const handleDocs = rowData => {
    console.log('row ==', rowData);
    if (!rowData || !rowData.column) {
      setDocsOpen(false);
      return;
    }

    setSelectedDocRow(rowData);
    fetchDocs(rowData.formId);

    switch (rowData.column.field) {
      case 'chipper_docs':
        setDocType('chipper_Docs');
        break;
      default:
        setDocType('');
    }
    setDocsOpen(prev => !prev);
  };

  const handleFileChange = _key => async file => {
    if (docType === '') {
      showToast('Kindly select a document type!');
      return;
    }
    const fileData = file?.[0];
    const formData = new FormData();
    formData.append('docketNumber', selectedRecord.formId);
    formData.append('docType', docType);
    formData.append('files', fileData);
    try {
      const response = await customFormAxios.post(`/Ops/AddDocketsDocs`, formData, { headers: authHeader() });
      if (response.status === 200) {
        showToast('File uploaded successfully', 'success');
        fetchDocs(selectedRecord.formId);
      }
    } catch (err) {
      console.error(err);
      showToast('Something went wrong', 'error');
    }
  };

  const handleDeleteFiles = fileDataToDelete => {
    if (!window.confirm('Are you sure you want to delete this Document?')) return;
    dispatch({ type: FETCH_START });
    customAxios
      .post('/Ops/DeleteDocketsDocs', { id: fileDataToDelete.id }, { headers: authHeader() })
      .then(data => {
        if (data.status === 200) {
          showToast('File deleted successfully.', 'success');
          fetchDocs(selectedRecord.formId);
        }
        dispatch({ type: FETCH_SUCCESS });
      })
      .catch(error => {
        console.error(error);
        dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
      });
  };

  const viewFile = async fileData => {
    try {
      dispatch({ type: FETCH_START });
      const response = await customAxios.get(`/Ops/GetDocketsFile/${fileData.id}`, {
        headers: authHeader(),
        responseType: 'blob',
      });
      const url = URL.createObjectURL(response.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileData.documentName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      dispatch({ type: FETCH_SUCCESS });
    } catch (err) {
      console.error(err);
      dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
    }
  };

  return {
    spList,
    spListObj,
    isModalOpen,
    setIsModalOpen,
    chipperData,
    handleSave,
    handleRecordDoubleClick,
    handleRowSelected,
    selectedRecord,
    isViewModalOpen,
    handleViewModalClose,
    docsOpen,
    selectedDocRow,
    setDocsOpen,
    handleDocs,
    handleFileChange,
    handleDeleteFiles,
    viewFile,
    files,
    docsLoading,
  };
};

export default useChipperLoader;
